import { useState } from "react";
import { FaTimes } from "react-icons/fa";

interface LightboxProps {
  url: string;
  isOpen: boolean;
  onClose: (e: React.MouseEvent<HTMLElement>) => void;
}

const Lightbox: React.FC<LightboxProps> = ({ url, isOpen, onClose }) => {
  if (!url) return null;

  const [padding, setPadding] = useState("56.25%");
  const imageLoad = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const img = event.currentTarget;
    const aspect = (img.naturalHeight / img.naturalWidth) * 100;
    setPadding(`${aspect}%`);
  };
  return (
    <div className={`image-lightbox ${isOpen ? "active" : ""}`}>
      <div className="image-center">
        <div style={{ paddingBottom: padding }} className="image-container">
          <a className="image-lightbox-close-btn" onClick={onClose}>
            <FaTimes size="20" />
          </a>
          <img onLoad={imageLoad} src={url} />
        </div>
      </div>
      <div className="image-lightbox-bg" onClick={onClose}></div>
    </div>
  );
};
export default Lightbox;
